import { type PlayerControlIntent } from '@endclock/shared';

/** Capture locomotion once when an interval first becomes visible. The same
 * intent must finish that command; changing it retroactively rewinds preview.
 * Aim/actions remain current because they do not change elapsed translation. */
export class PlayerCommandSampler {
  private movement: PlayerControlIntent | undefined;

  sample(proposed: PlayerControlIntent, consume: () => void, mayStartEarly: boolean): PlayerControlIntent {
    const previous = this.movement;
    const neutral = previous && Math.hypot(previous.x, previous.z, previous.vertical ?? 0) < 0.0001;
    if (!previous || (neutral && mayStartEarly && changedLocomotion(previous, proposed))) {
      this.movement = { ...proposed };
      consume();
    }
    const movement = this.movement!;
    return { ...proposed, x: movement.x, z: movement.z, gait: movement.gait,
      stance: movement.stance, vertical: movement.vertical ?? 0 };
  }

  finish(): void { this.movement = undefined; }
  cancel(): void { this.finish(); }
}

function changedLocomotion(a: PlayerControlIntent, b: PlayerControlIntent): boolean {
  return a.x !== b.x || a.z !== b.z || a.gait !== b.gait || a.stance !== b.stance || (a.vertical ?? 0) !== (b.vertical ?? 0);
}
